import { useCallback, useMemo, useState } from "react";

import { Person } from "@/Common/Models/Person/Person";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";

interface IPortalCommunicationMessageFormState {
    messageText: string;
    priority: SharedItemPriority;
    canPatientReplyWithMessage: boolean;
    subject?: string;
    patient?: Person;
}

interface UsePortalCommunicationMessageFormReturn {
    formState: IPortalCommunicationMessageFormState;
    isFormValid: boolean;
    onSetFormState: (newState: Partial<IPortalCommunicationMessageFormState>) => void;
}

const usePortalCommunicationMessageForm = (shouldValidatePatient: boolean = false): UsePortalCommunicationMessageFormReturn => {
    const [formState, setFormStateInternal] = useState<IPortalCommunicationMessageFormState>({
        messageText: "",
        priority: SharedItemPriority.Normal,
        canPatientReplyWithMessage: false,
        subject: null,
        patient: null
    });

    const isFormValid = useMemo(() => {
        const hasMessageOrSubject = !IsNullOrWhiteSpace(formState.messageText) || !IsNullOrWhiteSpace(formState.subject);
        return hasMessageOrSubject && (!shouldValidatePatient || formState.patient !== null);
    }, [formState.messageText, formState.subject, formState.patient, shouldValidatePatient]);

    const onSetFormState = useCallback((newState: Partial<IPortalCommunicationMessageFormState>) => {
        setFormStateInternal(prevState => ({
            ...prevState,
            ...newState
        }));
    }, []);

    return {
        formState,
        isFormValid,
        onSetFormState
    };
};
export { usePortalCommunicationMessageForm };
export type { IPortalCommunicationMessageFormState };
